import { apiClient } from "../API/axiosInstance";
import { formatDate, formatTemperature } from "../utils/formatters";
import { logger } from "../utils/logger";

/**
 * Service class for alert operations
 */
export class AlertsService {
  static async fetchOrganisationAlerts(orgID, startDate, endDate) {
    if (orgID === undefined || orgID === 0) return [];

    try {
      let url = `/organisation/alerts/${orgID}`;
      if (startDate && endDate) {
        url += `?startDate=${startDate}&endDate=${endDate}`;
      }

      const response = await apiClient.get(url);
      return response.data || [];
    } catch (error) {
      logger.error("Error fetching organisation alerts: ", error);
      return [];
    }
  }

  static async fetchDeviceAlerts(deviceId, startDate, endDate) {
    if (!deviceId) return [];

    try {
      let url = `/device/alerts/${deviceId}`;
      if (startDate && endDate) {
        url += `?startDate=${startDate}&endDate=${endDate}`;
      }

      const response = await apiClient.get(url);
      return response.data || [];
    } catch (error) {
      logger.error("Error fetching device alerts: ", error);
      return [];
    }
  }

  static getAlertTitle(tableMeta, t) {
    if (!tableMeta) return;
    if (!tableMeta.rowData) return;

    let alertType = tableMeta.rowData[4];
    let aboveBelow = tableMeta.rowData[5];
    let threshold = tableMeta.rowData[6];
    let out_of_hours = tableMeta.rowData[7];
    let start_time = tableMeta.rowData[8];
    let end_time = tableMeta.rowData[9];
    let true_false = tableMeta.rowData[15];
    let temp_value = tableMeta.rowData[18];

    let title = "";
    if (alertType === "temperature") {
      title = `${t("common.temperature")} ${aboveBelow} ${formatTemperature(
        threshold
      )}`;

      if (temp_value) {
        title = `${t("common.temperature")} ${aboveBelow} ${formatTemperature(
          threshold
        )} (${temp_value})`;
      }
    } else if (alertType === "humidity") {
      title = `${t("common.humidity")} ${aboveBelow} ${threshold}%`;
    } else if (alertType === "battery") {
      title = `${t("common.battery")} ${aboveBelow} ${threshold}%`;
    } else if (alertType === "movement") {
      title = `${t("common.movement")}`;
    } else if (alertType === "door") {
      title = `${t("actions.door")}`;
    } else if (alertType === "tilt") {
      title = `${t("actions.tilt")}`;
    } else if (alertType === "water_leak") {
      title = `${t("actions.water_leak")}`;
    }

    // Add additional context based on other conditions
    if (out_of_hours) {
      title += `${t("actions.out_of_hours")} between ${formatDate(
        start_time
      )} and ${formatDate(end_time)}`;
    }

    if (true_false === "true") {
      title += ` ${t("actions.geofence_enter")}`;
    } else if (true_false === "false") {
      title += ` ${t("actions.geofence_exit")}`;
    } else if (true_false === "enter_exit") {
      title += ` ${t("actions.geofence_enter_exit")}`;
    } else if (true_false === "motion") {
      title += ` ${t("actions.motion")}`;
    }

    return title;
  }

  static getForwarderTitle({ tableMeta, t }) {
    if (!tableMeta) return;
    if (!tableMeta.rowData) return;

    let forwarderURL = tableMeta.rowData[9];
    let title = "";
    title = `${t("actions.forwarder")} to ${forwarderURL}`;
    return title;
  }
}
